import React, { useEffect, useState } from "react";
import NavBar from "../../Component/NavBar/NavBar";
import { IoIosAddCircleOutline } from "react-icons/io";
import apiRequests from "../../Component/axios/config/config";
import Loading from "../../Component/Loading/Loading";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function Brands() {
  const navigate = useNavigate();

  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [typeSelected, setTypeSelected] = useState("PRODUCT");

  const [showModalEdit, setShowModalEdit] = useState("");
  const [updateProduct, setUpdateProduct] = useState("");
  const [name, setName] = useState("");
  const [BrandId, setBrandId] = useState("");
  const [search, setSearch] = useState("");

  const types = [
    { name: "Grocery Store", Type: "PRODUCT" },
    { name: "Order Food", Type: "FOOD" },
  ];

  useEffect(() => {
    ferchBrands(currentPage, search);
  }, [currentPage, updateProduct, typeSelected]);

  const ferchBrands = (page, searchValue= search) => {
    setLoading(true);

    const endpoint = `api/brand/get-all`;

    apiRequests
      .get(endpoint,{
          params: {
              page: currentPage,
              search: searchValue,
          }
      })
      .then((response) => {
        setBrands(response.data.data);
        setTotalPages(response.data.data.totalPages || " ");
      })
      .catch(() => {
        console.error("Failed to fetch Brands");
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = (id) => {};

  const handleEdit = (id, name) => {
    console.log(id, name);
    setBrandId(id);
    setName(name);
    setShowModalEdit(true);
  };

  const handleAdd = () => {
    navigate(`/brand/create`);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formatSpecifications = (specs) => {
    return Object.entries(specs || {}).map(([key, value]) => (
      <div key={key} className="text-xs">
        <span className="font-medium">{key}:</span> {value}
      </div>
    ));
  };

    const handleSearch = (value) => {
        setSearch(value);
        setCurrentPage(1);
        ferchBrands(1, value);
    };

  return (
    <div className="p-6">
      <div className="flex gap-4 items-center justify-between mb-6">
        <div className="text-3xl font-bold text-gray-800">Brand List</div>

        <div
          className={`w-fit flex justify-center gap-12 items-center md:gap-4 sm:hidden`}
        ></div>
      </div>

      <div
        className={`w-full justify-evenly items-center md:gap-4 hidden sm:flex mb-6`}
      >
        {types.map((item, index) => {
          return (
            <button
              onClick={() => {
                setTypeSelected(item.Type);
                setCurrentPage(1);
              }}
              key={index}
              className={`${typeSelected === item.Type ? "border-b border-[#FF8C42] text-[#FF8C42]" : "text-black border-none"} text-lg sm:text-[16px] font-bold`}
            >
              {item.name}
            </button>
          );
        })}
      </div>

      <NavBar
        item={[
          {
            icon: <IoIosAddCircleOutline />,
            title: "Add Brand",
            onClick: handleAdd,
          },
        ]}
        onSearch={handleSearch}
      />

      <div className="flex justify-center mt-8">
        <div className="w-full max-w-6xl md:overflow-x-auto">
          <table className="w-full bg-white shadow-md rounded-lg overflow-hidden">
            <thead className="bg-gradient-to-r from-purple-400 to-pink-500 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Parent
                </th>
                {/*<th className="px-6 py-3 text-left text-sm font-medium">Specifications</th>*/}
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Status
                </th>
                <th className="px-6 py-3 text-center text-sm font-medium">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {loading ? (
                <tr>
                  <td colSpan="5" className="px-6 py-4 text-center">
                    <Loading />
                  </td>
                </tr>
              ) : brands.length > 0 ? (
                brands.map((category) => (
                  <tr
                    key={category._id}
                    className="hover:bg-gray-100 transition duration-200"
                  >
                    <td className="px-6 py-4 text-gray-800 font-medium">
                      <Link to={`/category/${category._id}`}>
                        {category.name}
                      </Link>
                    </td>
                    <td className="px-6 py-4 text-gray-600">
                      {category.parent?.name || "None"}
                    </td>
                    {/*<td className="px-6 py-4 text-gray-600">*/}
                    {/*    {formatSpecifications(category.specifications)}*/}
                    {/*</td>*/}
                    <td className="px-6 py-4">
                      <span
                        className={`px-2 py-1 rounded-full text-xs font-medium 
                                            ${category.isDeleted ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}
                      >
                        {category.isDeleted ? "Deleted" : "Active"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <button
                        className="text-blue-500 hover:text-blue-700 font-medium mr-4"
                        onClick={() => handleEdit(category._id, category.name)}
                      >
                        Edit
                      </button>
                      <button
                        className="text-red-500 hover:text-red-700 font-medium"
                        onClick={() => handleDelete(category._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    className="px-6 py-4 text-center text-gray-500"
                  >
                    No brands found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {typeSelected !== "FOOD" && (
            <div className="flex justify-between items-center mt-4">
              <button
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="text-gray-700">
                Page {currentPage} of {totalPages}
              </span>
              <button
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          )}
        </div>
      </div>

      {showModalEdit && (
        <ModalEdit
          setShow={setShowModalEdit}
          setUpdateProduct={setUpdateProduct}
          updateProduct={updateProduct}
          name={name}
          setName={setName}
          id={BrandId}
        />
      )}
    </div>
  );
}

export function ModalEdit({
  setShow,
  id,
  name,
  setUpdateProduct,
  updateProduct,
  setName,
}) {
  const [loading, setLoading] = useState(false);

  function EditProduct() {
    setLoading(true);
    apiRequests
      .patch(`/api/brand/update`, {
        brandId: id,
        name: name,
      })
      .then((response) => {
        toast.success("successfully Edited Brand!");
        setUpdateProduct(!updateProduct);
        setShow(false);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }

  return (
    <div className="report-modal fixed inset-0 bg-black bg-opacity-60 transition-opacity">
      <div className="flex min-h-full items-end justify-center p-3 text-center">
        <div className="modal relative text-black transform overflow-hidden rounded-lg bg-white p-8 w-[30%] md:w-[95%] m-auto flex flex-col gap-5">
          <div className="flex flex-col gap-5 text-gray-500 ">
            <div>
              <label className="block mb-2 font-medium text-left">
                Brand Name
              </label>
              <input
                type="text"
                className="w-full p-2 border rounded-lg"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
          </div>

          <div className="flex justify-center items-center gap-5 ">
            <button
              className="px-4 py-1 border-2 hover:bg-green-600 hover:text-white rounded-lg border-green-600 text-green-600"
              onClick={EditProduct}
            >
              {loading ? <Loading /> : "Edit"}
            </button>

            <button
              className="hover:bg-gray-300 border-2 px-4 py-1 rounded-lg"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
